<button
  class="chipFilterDs__cont chipFilterDs__cont--{{priority}}-{{size}} chipFilterDs__cont--{{state}}" aria-label="chipFilterDs">
  <ng-container *ngFor="let option of options | slice : 0 : slice; trackBy: trackById; last as isLast">
    <div class="chipFilterDs__option">
      <div
        class="chipFilterDs__option-chip chipFilterDs__option-chip--{{priority}}-{{size}} chipFilterDs__option-chip--{{state}}"
        [class.without-text]="withoutText"
        (click)="clickEventTrigger(option)">
        <ng-container *ngIf="option.Icon">
          <div class="chipFilterDs__icon" [class.without-text]="withoutText">
            <app-ds-icon
              [icon]="option.Icon"
              [color]="iconFillColor(option.SpecialIcon)"
              [size]="iconSize">
            </app-ds-icon>
          </div>
        </ng-container>
        <ng-container *ngIf="option.Label">
          <div class="chipFilterDs__label">
            <app-ds-typography
              [size]="fontSize"
              [fontFamily]="fontFamily.SemiBold"
              [color]="fontColor"
              [text]="option.Label">
            </app-ds-typography>
          </div>
        </ng-container>
        <ng-container *ngIf="action">
          <div class="chipFilterDs__action">
            <app-ds-icon
              [icon]="action"
              [color]="iconFillColor(false)"
              [size]="actionSize">
            </app-ds-icon>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="!isLast">
        <div class="chipFilterDs__divider">
          <app-ds-divider
            [orientation]="dividerOrientation">
          </app-ds-divider>
        </div>
      </ng-container>
    </div>
  </ng-container>
</button>